import React from 'react';
import { map } from 'lodash';
import CircularProgress from '@material-ui/core/CircularProgress';

import { DashboardTable, Graph } from '../../components';

import './ArtistDetailDashboard.scss';

const ArtistDetailsDashboard = ({ artist, setArtist, dashboardData = [], filter, isLoading = false, error = null }) => {
  const totalRevenue = dashboardData?.total_views ? dashboardData.total_views * 0.003 : 0;
  const changeTotalView = dashboardData?.change_in_views;
  const changeTotalLikes = dashboardData?.change_in_likes;

  console.log("Dashboard Data", dashboardData);
  const viewData = dashboardData?.viewData ? map(dashboardData.viewData, (item) => ({
    date: item._id,
    total_logs: item.total,
  })) : [];

  // Format currency with commas and 2 decimal places
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  };

  // Format change value with +/- and % sign
  const formatChange = (value) => {
    if (value == null) return '0%';
    const sign = value > 0 ? '+' : '';
    return `${sign}${value.toFixed(2)}%`;
  };

  // Check if dashboard data is empty
  const isEmpty = !isLoading && !error && (!dashboardData || 
    (!dashboardData.total_songs && 
     !dashboardData.total_views && 
     !dashboardData.total_likes && 
     (!dashboardData.viewData || dashboardData.viewData.length === 0)));

  // Loading state
  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '400px',
        width: '100%' 
      }}>
        <CircularProgress />
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column',
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '400px',
        width: '100%',
        padding: '20px',
        textAlign: 'center'
      }}>
        <h4 style={{ 
          marginBottom: 20, 
          fontSize: 20, 
          lineHeight: '32px',
          color: '#d32f2f'
        }}>
          Error loading dashboard data
        </h4>
        <p style={{ color: '#666', fontSize: 14 }}>
          {error.message || 'Something went wrong. Please try again later.'}
        </p>
      </div>
    );
  }

  // Empty state
  if (isEmpty) {
    return (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column',
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '400px',
        width: '100%',
        padding: '20px',
        textAlign: 'center'
      }}>
        <h4 style={{ 
          marginBottom: 20, 
          fontSize: 20, 
          lineHeight: '32px',
          maxWidth: '60%',
          marginInline: 'auto'
        }}>
          No Dashboard Data Available
        </h4>
        <p style={{ color: '#666', fontSize: 14 }}>
          There is no data to display for this artist at the moment.
        </p>
      </div>
    );
  }

  return (
    <div>
      <div className={'Dashboard'}>
        <div className={'detailBox'}>
          <div className={'box1'}>
            <p className={'subTitle'}>Total Songs </p>
            <p className={'currency'}>{dashboardData?.total_songs}</p>
          </div>

          <div className={'box2'}>
            <p className={'subTitle'}>Total Revenue</p>
            <div className={'currency1'}>
              <p className={'value'}>{formatCurrency(totalRevenue)}</p>
              {/* <p className={'change'}>+ 36%</p> */}
            </div>
          </div>
          <div className={'box2'}>
            <p className={'subTitle'}>Total Views</p>
            <div className={'currency1'}>
              <p className={'value'}>{dashboardData?.total_views}</p>
              <p
                className={'change'}
                style={{
                  color: changeTotalView > 0 ? 'green' : 'red',
                }}
              >
                {formatChange(changeTotalView)}
              </p>
            </div>
          </div>
          <div className={'box2'}>
            <p className={'subTitle'}>Total Likes</p>
            <div className={'currency1'}>
              <p className={'value'}>{dashboardData?.total_likes}</p>
              <p
                className={'change'}
                style={{
                  color: changeTotalLikes > 0 ? 'green' : 'red',
                }}
              >
                {formatChange(changeTotalLikes)}
              </p>
            </div>
          </div>
        </div>

        <div className={'graphContainerMain'}>
          <div className={'conntainer1'}>
            <p className={'titlegraph'}>Views</p>
            <div className={'graphContainer'}>
              <Graph data={viewData} graphFilter={filter} type="View" />
            </div>
          </div>
          <div className={'conntainer2'}>
            <p className={'titlegraph'}>Earnings</p>
            <div className={'graphContainer'}>
              <Graph data={viewData} graphFilter={filter} type="Earning" />
            </div>
          </div>
        </div>

        <div className={'tableContainer'}>
          <DashboardTable data={dashboardData} />
          <DashboardTable type="down" data={dashboardData} />
        </div>
      </div>
    </div>
  );
};

export default ArtistDetailsDashboard;

